import { Sec2 } from "./../Sec2/Sec2";
export function Home(){
    return(
         
         <Sec2/> 
        
        
    )
}